import { RouteConfig } from 'vue-router'

export const JOB_DETAILS_PATH = '/job/:uuid'
export const JOB_DETAILS_NAME = 'JobDetailsView'

export const JOB_LIST_PATH = '/job-list'
export const JOB_LIST_NAME = 'JobListView'

export const jobRoutesByUuidConfig: RouteConfig[] = [
  {
    path: JOB_DETAILS_PATH,
    name: JOB_DETAILS_NAME,
    component: () => import('@/features/job/views/JobDetails.vue')
  }
]

export const jobRoutesConfig: RouteConfig[] = [
  {
    path: JOB_LIST_PATH,
    name: JOB_LIST_NAME,
    component: () => import('@/features/job/views/JobList.vue')
  }
]
